import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';

import TkForm from '@/../bower_components/teknisavuecomponents/components/TkForm.vue';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import MarcacaoRepository from '@/assets/ts/offline/repository/MarcacaoRepository';
import Field from '@/../bower_components/teknisavuecomponents/assets/interfaces/Field';


@Component({
  name: 'DetalhesRegistroOfflinePopup',
  components: {
    TkForm
  },
})
class DetalhesRegistroOfflinePopup extends Vue {

  // #region [ PROPS ]
  @Prop({ default: false })
  private readonly value: boolean;

  @Prop({ default: null })
  private readonly marcacao: any;

  @Prop({ default: false })
  private readonly isEdit: boolean;

  // #region [ EVENTS ]
  @Emit('after-save')
  private emitAfterSave() {}

  @Emit('input')
  private emitInput(value: boolean) {}

  // #region [ WATCHERS ]
  @Watch('value', { immediate: true })
  private valueOnChange() {
    this.internalValue = this.value;
    this.row.NRCHAVEVINCULO = this.marcacao.NRCHAVEVINCULO;
  }

  private get cardTitle(): string {
    const nmVinculo = this.marcacao.NMVINCULOM || '';
    const dataMarcacao = this.marcacao.DTHRMARCACAOPONTO || '';
    if (this.isEdit) {
      return `Editar - ${nmVinculo} - ${dataMarcacao}`;
    }

    return `Detalhes - ${nmVinculo} - ${dataMarcacao}`;
  }

  private internalValue = false;
  private loading = false;
  private row: any = {};

  private get fields(): Field[] {
    const fields = [
      {
        name: 'NRCHAVEVINCULO',
        label: 'Nr. Vínculo / CPF',
        type: 'text',
        size: 12,
      },
    ];

    return fields;
  }

  // #region [ METHODS ]
  private closePopup() {
    this.internalValue = false;
    this.emitInput(this.internalValue);
    this.row = {};
  }

  private onFieldInput(fieldName, value) {
  }

  private async saveEdit() {

    const chave = this.tratarChave(this.row.NRCHAVEVINCULO);

    if (!chave) {
      const message = 'Digite um valor válido!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);
    }

    const row = { 
      NRCHAVEVINCULO: chave,
      NRMARCACAOOFFLINE: this.marcacao.NRMARCACAOOFFLINE
    };

    try {
      const response = await MarcacaoRepository.updateChaveMarcacao(row);

      this.closePopup();
      this.emitAfterSave();
    } catch (error) {
      const message = 'Não foi possível atualizar a chave dessa marcação!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);
    }

  }

  private getStatusMarcacao() {
    const status = {
      S: 'Sincronizado',
      N: 'Não sincronizado',
      P: 'Pendente'
    }

    if(!this.marcacao.IDSINCRONIZADO) return status.P;

    return status[this.marcacao.IDSINCRONIZADO];
  }

  private tratarChave(input: string) {
    return input.replace(/\D/g, '');
  }

}

export default DetalhesRegistroOfflinePopup;